import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { color, getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import { ChevronDown } from '@magalu/stereo-ui-icons';
import Link from '../Link';
import Box from '../Box';
import Flex from '../Flex';
const DropdownItem = styled(Flex).attrs(props => Object.assign({
  color: 'text.base',
  alignItems: 'center',
  p: 3
}, props))``;
export const Container = styled(Box).attrs(props => Object.assign({
  display: 'inline-block'
}, props))``;
export const ContainerTitle = styled(Link).attrs(_ref => {
  let {
    pointing
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isOpen", "pointing"]);

  return Object.assign({
    position: 'relative',
    fontSize: 1,
    py: pointing ? 3 : 2,
    gridGap: 1
  }, props);
})``;
export const ContainerMenu = styled(Box).attrs(_ref2 => {
  let props = _objectWithoutPropertiesLoose(_ref2, ["pointing"]);

  return Object.assign({
    position: 'absolute',
    color: 'text.base',
    bg: 'background.lighter',
    borderRadius: 'medium',
    zIndex: 1,
    minWidth: '10rem',
    maxHeight: '20rem',
    forwardedAs: 'ul'
  }, props);
})`
  border: ${themeGet('borders.0')};

  ${({
  pointing
}) => pointing && css`
      &::before,
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 19px;
        border: 11px solid transparent;
        border-bottom-color: ${themeGet('borders.0')};
      }

      &::after {
        left: 20px;
        border: 10px solid transparent;
        border-bottom-color: ${getBackgroundColor('lighter')};
      }
    `}
`;
export const ContainerItem = styled(DropdownItem)`
  gap: ${themeGet('space.1')}px;
  ${({
  disableHover
}) => !disableHover && css`
      &:hover {
        background-color: ${getBackgroundColor('darker')};
      }
    `}
`;
export const ContainerLabel = styled(DropdownItem)`
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
`;
export const ContainerIcon = styled(ChevronDown)`
  width: 20px;
  height: 20px;
  transition: transform 0.25s ease-out;
  transform: ${({
  rotated
}) => rotated && 'rotate(-180deg)'};
  ${color}
`;